import { createApp } from 'vue';
import { installHttpClient } from './plugins/http';

// Plugins
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

import VueGoogleMaps from '@fawmi/vue-google-maps';

// Components
import Login from './components/login/Login.vue';
import Register from './components/login/Register.vue';
import InboundUpload from './components/inbound/InboundUpload.vue';
import MenuTabs from './components/MenuTabs.vue';
import Advertisements from './components/advertisements/advertisements/Advertisements.vue';
import AdvertisementCreate from './components/advertisements/create/AdvertisementCreate.vue';
import AdvertisementCreateExternal from './components/advertisements/create/AdvertisementCreateExternal.vue';
import Campaigns from './components/campaigns/campaigns/Campaigns.vue';
import CampaignCreate from './components/campaigns/create/CampaignCreate.vue';
import CampaignShow from './components/campaigns/campaigns/CampaignShow.vue';
import CampaignModeration from './components/campaigns/moderation/CampaignModeration.vue';
import ModerationExternal from './components/campaigns/moderation/ModerationExternal.vue';
import AdvertisementModeration from './components/advertisements/AdvertisementModeration.vue';
import AdvertisementModerationExternal from './components/advertisements/moderation/AdvertisementModerationExternal.vue';
import CreativeModeration from './components/creatives/moderation/CreativeModeration.vue';
import Creatives from './components/creatives/creatives/Creatives.vue';
import CreativeCreate from './components/creatives/create/CreativeCreate.vue';
import GuaranteedCreatives from './components/guaranteed/GuaranteedCreatives.vue';
import RtbCreatives from './components/rtb/RtbCreatives.vue';
import RtbCampaignsList from './components/rtb/campaigns/list/RtbCampaignsList.vue';
import RTBCampaignForm from './components/rtb/campaigns/RTBCampaignForm.vue';
import RTBCampaignStatistics from './components/rtb/campaigns/RTBCampaignStatistics.vue';
import RTBPackageCampaignForm from './components/rtb/campaigns/RTBPackageCampaignForm.vue';
import PoiLayersList from './components/rtb/poi/PoiLayersList.vue';
import PoiLayerForm from './components/rtb/poi/PoiLayerForm.vue';
import SmsRequestsList from './components/rtb/sms/SmsRequestsList.vue';
import SmsRequestForm from './components/rtb/sms/SmsRequestForm.vue';
import ImpressionStats from './components/impression-stats/ImpressionStats.vue';
import RTBRequests from './components/rtb-requests/RTBRequests.vue';
import Help from './components/help/Help.vue';
import HelpRtb from './components/help/HelpRtb.vue';
import HelpAgency from './components/help/HelpAgency.vue';
import CampaignFlow from './components/campaign-flow/CampaignFlow.vue';
import UserProfile from './components/profile/UserProfile.vue';
import ChangePassword from './components/profile/ChangePassword.vue';
import Requirements from './components/requirements/Requirements.vue';
import AdminPanel from './components/admin/AdminPanel.vue';
import ModerationPanel from './components/admin/ModerationPanel.vue';
import PartnersList from './components/partners/PartnersList.vue';
import AdvertisersList from './components/advertisers/AdvertisersList.vue';
import BrandsList from './components/brands/BrandsList.vue';
import CampaignsListPage from './components/campaigns-list/CampaignsListPage.vue';
import PublicScreenCatalog from './components/public/PublicScreenCatalog.vue';
import ToastHost from './components/ui/ToastHost.vue';
import ConfirmHost from './components/ui/ConfirmHost.vue';

installHttpClient();

const app = createApp({});

// Register components
app.component('toast-host', ToastHost);
app.component('confirm-host', ConfirmHost);
app.component('login', Login);
app.component('register', Register);
app.component('inbound-upload', InboundUpload);
app.component('menu-tabs', MenuTabs);
app.component('advertisements', Advertisements);
app.component('advertisement-create', AdvertisementCreate);
app.component('advertisement-create-external', AdvertisementCreateExternal);
app.component('campaigns', Campaigns);
app.component('campaign-create', CampaignCreate);
app.component('campaign-show', CampaignShow);
app.component('campaign-moderation', CampaignModeration);
app.component('moderation-external', ModerationExternal);
app.component('advertisement-moderation', AdvertisementModeration);
app.component('advertisement-moderation-external', AdvertisementModerationExternal);
app.component('creative-moderation', CreativeModeration);
app.component('creatives', Creatives);
app.component('creative-create', CreativeCreate);
app.component('guaranteed-creatives', GuaranteedCreatives);
app.component('rtb-creatives', RtbCreatives);
app.component('rtb-campaigns-list', RtbCampaignsList);
app.component('rtb-campaign-form', RTBCampaignForm);
app.component('rtb-campaign-statistics', RTBCampaignStatistics);
app.component('rtb-package-campaign-form', RTBPackageCampaignForm);
app.component('poi-layers-list', PoiLayersList);
app.component('poi-layer-form', PoiLayerForm);
app.component('sms-requests-list', SmsRequestsList);
app.component('sms-request-form', SmsRequestForm);
app.component('impression-stats', ImpressionStats);
app.component('rtb-requests', RTBRequests);
app.component('help', Help);
app.component('help-rtb', HelpRtb);
app.component('help-agency', HelpAgency);
app.component('campaign-flow', CampaignFlow);
app.component('user-profile', UserProfile);
app.component('change-password', ChangePassword);
app.component('requirements', Requirements);
app.component('admin-panel', AdminPanel);
app.component('moderation-panel', ModerationPanel);
app.component('partners-list', PartnersList);
app.component('advertisers-list', AdvertisersList);
app.component('brands-list', BrandsList);
app.component('campaigns-list-page', CampaignsListPage);
app.component('public-screen-catalog', PublicScreenCatalog);
// Use plugins
app.use(ElementPlus);
app.use(VueTippy);
app.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_MAPS_API_KEY,
        loading: 'async',
    },
});

app.mount('#app');
